import { render, staticRenderFns } from "./core.vue?vue&type=template&id=0f501a38&scoped=true"
import script from "./core.vue?vue&type=script&lang=js"
export * from "./core.vue?vue&type=script&lang=js"
import style0 from "./core.vue?vue&type=style&index=0&id=0f501a38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_babel-core@6.26.3_coffee-script@1.12.7_css-_8aef9a3e041715d48f8446645dd2da9a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f501a38",
  null
  
)

export default component.exports